import i18n from '@/lang/i18n'

export default [
  {
    path: '/admin/site/apply',
    name: 'ApplyList',
    component: () => import('@/views/site/apply/list/index'),
    meta: {
      title: i18n.t('router.site.my_apps'),
      keepAlive: false,
      headType: 1,
      auth: true
    }
  },
  {
    path: '/admin/site/apply/add',
    name: 'AddApply',
    component: () => import('@/views/site/apply/list/edit'),
    meta: {
      title: i18n.t('router.site.add_app'),
      keepAlive: false,
      headType: 1,
      auth: true
    }
  },
  {
    path: '/admin/site/apply/edit',
    name: 'EditApply',
    component: () => import('@/views/site/apply/list/edit'),
    meta: {
      title: i18n.t('router.site.edit_app'),
      keepAlive: false,
      headType: 1,
      auth: true
    }
  },
  {
    path: '/admin/site/log_list',
    name: 'LogList',
    component: () => import('@/views/site/apply/log_list'),
    meta: {
      title: i18n.t('router.site.operation_log'),
      keepAlive: false,
      headType: 1,
      auth: true
    }
  }, {
    path: '/admin/site/station/system_update',
    name: 'SystemUpdate',
    component: () => import('@/views/site/station/system_update'),
    meta: {
      title: i18n.t('router.site.system_update'),
      keepAlive: false,
      headType: 1,
      auth: true
    }
  },
  {
    path: '/admin/site/station/storage',
    name: 'Storage',
    component: () => import('@/views/site/station/storage'),
    meta: {
      title: i18n.t('router.site.storage_config'),
      keepAlive: false,
      headType: 1,
      auth: true
    }
  },
  {
    path: '/admin/site/station/station_setting',
    name: 'StationSetting',
    component: () => import('@/views/site/station/station_setting'),
    meta: {
      title: i18n.t('router.site.site_settings'),
      keepAlive: false,
      headType: 1,
      auth: true
    }
  },
  {
    path: '/admin/site/employees_list',
    name: 'EmployeesList',
    component: () => import('@/views/site/power/employees_list'),
    meta: {
      title: i18n.t('router.site.account_manage'),
      keepAlive: false,
      headType: 1,
      auth: true
    }
  },
  {
    path: '/admin/site/plug_list',
    name: 'PlugList',
    component: () => import('@/views/site/plug/plug_list'),
    meta: {
      title: i18n.t('router.site.plugin_list'),
      keepAlive: false,
      headType: 1,
      auth: true
    }
  },
  {
    path: '/admin/site/order_list',
    name: 'PrivateOrderList',
    component: () => import('@/views/site/plug/order_list'),
    meta: {
      title: i18n.t('router.site.my_orders'),
      keepAlive: false,
      headType: 1,
      auth: true
    }
  },
  {
    path: '/admin/site/plugin_details',
    name: 'PluginDetails',
    component: () => import('@/views/site/plug/plugin_details'),
    meta: {
      title: i18n.t('router.site.plugin_details'),
      keepAlive: false,
      headType: 1,
      auth: true
    }
  },
  {
    path: '/admin/site/super/config',
    name: 'PrivateSuperConfig',
    component: () => import('@/views/site/super/config'),
    meta: {
      title: i18n.t('router.site.account_settings'),
      keepAlive: false,
      headType: 1,
      auth: true
    }
  },
  {
    path: '/admin/site/plug_package',
    name: 'PrivatePlugPackage',
    component: () => import('@/views/site/plug/plug_package'),
    meta: {
      title: i18n.t('router.site.plugin_package'),
      keepAlive: false,
      headType: 1,
      auth: true
    }
  },
  {
    path: '/admin/site/auth_info',
    name: 'PrivateAuthInfo',
    component: () => import('@/views/site/auth/auth_info'),
    meta: {
      title: i18n.t('router.site.site_authorization'),
      keepAlive: false,
      headType: 1,
      auth: true
    }
  },
  {
    path: '/admin/site/station/sms_settings',
    name: 'SmsSettings',
    component: () => import('@/views/site/station/sms_settings'),
    meta: {
      title: i18n.t('router.site.sms_settings'),
      keepAlive: false,
      headType: 1,
      auth: true
    }
  },
  {
    path: '/admin/site/station/login_settings',
    name: 'LoginSettings',
    component: () => import('@/views/site/station/login_settings'),
    meta: {
      title: i18n.t('router.site.login_settings'),
      keepAlive: false,
      headType: 1,
      auth: true
    }
  },
  {
    path: '/admin/site/plug_package_record',
    name: 'PrivatePlugPackageRecord',
    component: () => import('@/views/site/plug/plug_package_record'),
    meta: {
      title: i18n.t('router.site.package_records'),
      keepAlive: false,
      headType: 1,
      auth: true
    }
  },
  {
    path: '/admin/site/apply/plugin',
    name: 'PrivateApplyPlugin',
    component: () => import('@/views/site/apply/plugin'),
    meta: {
      title: i18n.t('router.site.plugin_authorization'),
      keepAlive: false,
      headType: 1,
      auth: true
    }
  },
  {
    path: '/admin/site/apply/managers',
    name: 'ManagersApply',
    component: () => import('@/views/site/apply/managers'),
    meta: {
      title: i18n.t('router.site.manager'),
      keepAlive: false,
      headType: 1,
      auth: true
    }
  }
]



// WEBPACK FOOTER //
// ./src/router/site.js